import React from 'react';
import { Button, Form, Input } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Field, ToggleField } from '@src/components/Common/Form';
import RateLimitFields from '@src/components/LLMModels/LLMForms/RateLimitFields';

/** A GenAI endpoint is two URLs and a secret, then whatever the body needs. */
const GenAIModelForm = () => (
    <>
        <Field
            name={['extra_data', 'token_url']}
            label="JWT auth URL"
            span={6}
            hint="Where the JWT is asked for."
            rules={[
                { required: true, message: 'Enter the JWT auth URL' },
                { type: 'url', message: 'Enter a full URL, including https://' },
            ]}
        >
            <Input className="nf-mono" placeholder="https://auth.example.com/token" inputMode="url" autoComplete="off" />
        </Field>

        <Field
            name={['extra_data', 'request_url']}
            label="Chat completion URL"
            span={6}
            hint="Where the completion request goes."
            rules={[
                { required: true, message: 'Enter the chat completion URL' },
                { type: 'url', message: 'Enter a full URL, including https://' },
            ]}
        >
            <Input
                className="nf-mono"
                placeholder="https://api.example.com/v1/chat/completions"
                inputMode="url"
                autoComplete="off"
            />
        </Field>

        <Field
            name={['extra_data', 'credentials']}
            label="Credentials"
            span={6}
            hint="Blank keeps the secret already stored."
        >
            <Input.Password
                className="nf-mono"
                placeholder="Enter credentials"
                visibilityToggle={false}
                autoComplete="new-password"
            />
        </Field>

        <ToggleField
            name={['extra_data', 'verify_ssl']}
            span={6}
            label="Verify SSL"
            hint="Check the server's certificate."
        />

        <RateLimitFields />

        {/* the body the model is called with, minus `messages` — that one is ours */}
        <Field
            label="Request parameters"
            span={8}
            hint="Merged into the request body — temperature, max_tokens, and the like."
        >
            <Form.List name={['extra_data', 'request_payload_entries']}>
                {(fields, { add, remove }) => (
                    <div className="llm-params">
                        {fields.map(({ key, name, ...restField }) => (
                            <div className="llm-params__row" key={key}>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'key']}
                                    rules={[
                                        { required: true, message: 'Key is required' },
                                        {
                                            validator: (_, value) =>
                                                value === 'messages'
                                                    ? Promise.reject(new Error("'messages' is not allowed"))
                                                    : Promise.resolve(),
                                        },
                                    ]}
                                    style={{ flex: 1, marginBottom: 0 }}
                                >
                                    <Input placeholder="temperature" aria-label={`Parameter ${name + 1} key`} />
                                </Form.Item>
                                <span className="llm-params__eq" aria-hidden="true">
                                    =
                                </span>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'value']}
                                    rules={[{ required: true, message: 'Value is required' }]}
                                    style={{ flex: 1, marginBottom: 0 }}
                                >
                                    <Input placeholder="0.7" aria-label={`Parameter ${name + 1} value`} />
                                </Form.Item>
                                <Button
                                    type="text"
                                    danger
                                    icon={<MinusCircleOutlined />}
                                    onClick={() => remove(name)}
                                    aria-label={`Remove parameter ${name + 1}`}
                                />
                            </div>
                        ))}
                        <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />} block>
                            Add parameter
                        </Button>
                    </div>
                )}
            </Form.List>
        </Field>
    </>
);

export default GenAIModelForm;
